import { createContext } from "react";

const PictureContext = createContext();

export default PictureContext;
